/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_VerInputs */

const en_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ar_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاناً`)
};

const de_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kostenlos`)
};

const es_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuitement`)
};

const it_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ja_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const ko_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

const pt_br_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gratuitamente`)
};

const ru_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const th_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const tr_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const zh_cn_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

const zh_tw_free_ver = /** @type {(inputs: Free_VerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Free_VerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free_ver = /** @type {((inputs?: Free_VerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_VerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_ver(inputs)
	if (locale === "ar") return ar_free_ver(inputs)
	if (locale === "de") return de_free_ver(inputs)
	if (locale === "es") return es_free_ver(inputs)
	if (locale === "fr") return fr_free_ver(inputs)
	if (locale === "it") return it_free_ver(inputs)
	if (locale === "ja") return ja_free_ver(inputs)
	if (locale === "ko") return ko_free_ver(inputs)
	if (locale === "pt_br") return pt_br_free_ver(inputs)
	if (locale === "ru") return ru_free_ver(inputs)
	if (locale === "th") return th_free_ver(inputs)
	if (locale === "tr") return tr_free_ver(inputs)
	if (locale === "zh_cn") return zh_cn_free_ver(inputs)
	return zh_tw_free_ver(inputs)
});